import * as React from "react";
import type { SVGProps } from "react";
const SvgLayers03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m17.4 9.822 4.2 2.153-9.6 4.92-9.6-4.92 4.277-2.192M17.4 14.526l4.2 2.153L12 21.6l-9.6-4.92 4.277-2.193M12 2.4l9.6 4.92-9.6 4.922L2.4 7.32z"
    />
  </svg>
);
export default SvgLayers03;
